import { useState, useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import api from "../../services/api";
import Spinner from "../../shared/Spinner/Spinner";
import Style from "./ContractTableStyle";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import { FaRegCheckCircle, FaRegCircle, FaFileDownload } from "react-icons/fa";
import download from 'downloadjs'
import InputFile from "../../components/InputFile/InputFile";
import { AxiosRequestConfig } from "axios";
import { ProgressBar } from "react-bootstrap";
import PageTitle from "../../components/PageTitle";

export default function ContractTable(props) {
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const [contracts, setContracts] = useStateIfMounted({} as any);

  const [selectedSignedContract, setSelectedSignedContract] = useState({} as File);
  const [isSignedContractSelected, setIsSignedContractSelected] = useState(false);
  const [contractIdToUploadSignedContract, setContractIdToUploadSignedContract] = useState(0);
  const [uploadingContract, setUploadingContract] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);

  useEffect(() => {
    LoadContracts();
  }, []);

  async function LoadContracts() {
    setLoading(true);
    try {
      const result = await api.get("/contracts");
      if (result.data.success) {
        const contracts = result.data.contracts;
        setContracts(contracts);
        setErrorMessage("");
      } else {
        setErrorMessage("Não foi possível consultar os contratos: " + result.data)
      }
    } catch (error) {
      setErrorMessage("Erro ao consultar os contratos: " + error);
    }
    finally {
      setLoading(false);
    }
  }

  async function DownloadContract(contractId) {
    const response = await api.get(`contracts/${contractId}`, {
      responseType: 'blob', // had to add this one here
    });
    const content = response.headers['content-type'];
    download(response.data, `Contrato DecoraApp ${contractId}`, content);
  }
  async function DownloadContractSigned(contractId) {
    const response = await api.get(`contracts/${contractId}/signedContract`, {
      responseType: 'blob', // had to add this one here
    });
    const content = response.headers['content-type'];
    download(response.data, `Contrato DecoraApp ${contractId}`, content);
  }

  function ChangeSelectedSignedContract(event, contractId) {
    const file = event.target.files[0];
    setContractIdToUploadSignedContract(contractId);
    setSelectedSignedContract(file);
    setIsSignedContractSelected(true);
  };

  function UnselectSignedContract() {
    setContractIdToUploadSignedContract(0);
    setSelectedSignedContract({} as File)
    setIsSignedContractSelected(false);
  }

  async function UploadSignedContract() {
    setUploadingContract(true);

    try {
      const options: AxiosRequestConfig = {};
      const formData = new FormData();

      if (isSignedContractSelected) {
        formData.append("signedContract", selectedSignedContract, selectedSignedContract.name);
        options.onUploadProgress = progressEvent => {
          const { loaded, total } = progressEvent;
          const percentage = Math.floor(loaded * 100 / total);
          setUploadPercentage(percentage);
          console.log(`${loaded}kb de ${total}kb | ${percentage}% carregados`);
        }
      }

      const orderId = contractIdToUploadSignedContract;
      formData.append("orderId", orderId.toString());
      const request = api.post(`/contracts/${orderId}/signedContract`, formData, options);
      const result = await request;

      setUploadingContract(false);
      setSelectedSignedContract({} as File);
      setIsSignedContractSelected(false);
      console.log(result);
    }
    catch (error: any) {
      setUploadingContract(false);
      setSelectedSignedContract({} as File);
      setIsSignedContractSelected(false);

      setErrorMessage(error?.response?.data?.message);
      console.error(error);
    }
  }

  function onContractFile(contract) {
    const hasSignedUrl = contract.signedContract && contract.signedContractURL;
    return (
      <div className="fileContract action">
        {contract.url && (
          <button className="downloadButton" onClick={() => {
            hasSignedUrl ? DownloadContractSigned(contract.id) : DownloadContract(contract.id);
          }}>
            <FaFileDownload className="icon" />
          </button>)
        }
        {!contract.signedContract && (
          <div>
            <InputFile
              id="signedContract"
              name="signedContract"
              text="Enviar contrato assinado"
              disabled={uploadingContract}
              accept="application/pdf"
              onChange={(event) => ChangeSelectedSignedContract(event, contract.id)}
            />
          </div>
        )
        }
        {!contract.signedContract &&
          contract.d4sign_contracts.length > 0 &&
          contract.d4sign_contracts[0].contractUrl &&
          (<a className="button" href={contract.d4sign_contracts[0].contractUrl}>Visualizar externo</a>)
        }
      </div >
    );
  }

  return (
    <Style>
      <PageTitle title="Contratos" />
      <TwoButtonsModal
        show={isSignedContractSelected}
        onHide={UnselectSignedContract}
        loading={uploadingContract}
        title="Enviar contrato assinado!"
        body={`Você tem certeza que o arquivo é o contrato assinado?`}
        secondaryText="Não"
        secondaryOnClick={UnselectSignedContract}
        secondaryDisabled={uploadingContract}
        primaryText="Sim"
        primaryOnClick={UploadSignedContract}
        primaryDisabled={loading}
      />
      {errorMessage !== "" && <p className="alert alert-error">Erro: {errorMessage}</p>}

      {uploadingContract &&
        <div>
          <label htmlFor="file">Progresso do Upload:</label>
          <ProgressBar variant="success" now={uploadPercentage} label={`${uploadPercentage}%`} />
        </div>
      }
      <section className="table-title">
        <h1>Contratos</h1>
        {/* <button onClick={() => props.history.push('#')}>Novo template</button> */}
      </section>
      <table className="table table-striped table-bordered table-hover ">
        <thead>
          <tr>
            <th>Id</th>
            <th>Usuário</th>
            <th>Bloco</th>
            <th>Apartamento</th>
            <th>Assinado</th>
            <th>Data</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <Spinner spinning={loading} />
          {contracts?.length > 0 && contracts.map(contract => {
            return (
              <tr key={contract.id}>
                <td>{contract.id}</td>
                <td>{contract.userName}</td>
                {/* Mantém em uma só linha */}
                <td>{`${contract.apartmentBlock}`}</td>
                <td>{contract.apartmentNumber}</td>
                <td>{contract.signedContract ? <FaRegCheckCircle /> : <FaRegCircle />}</td>
                <td>{new Date(contract.date).toLocaleString()}</td>
                <td>
                  {onContractFile(contract)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Style>
  );
}
